import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id BC54AA3D-A450-4079-B40C-457FAE2211D5
 * name menu-left-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-left-outline.svg
 * tags
 */
export const MenuLeftOutlineIcon = createSvgIcon(<><path d="M15,18H13.5L7.5,12L13.5,6H15V18M10.33,12L13,14.67V9.33L10.33,12Z" /></>, 'MenuLeftOutlineIcon');
export default MenuLeftOutlineIcon